import { useForm } from "@mantine/form";
import { Button, Flex, Loader, Center, PasswordInput, Select, TextInput } from "@mantine/core";
import { useNavigate, useParams } from "react-router";
import { createHrUser } from "../../api/hrUserApi";
import { creationNotification } from "../../utils/useNotification";
import Container from "../common/Container";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import styled from "styled-components";
import {
  combineValidators, validateMaxLength, validateMinLength,
  validateNoSpaces, validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero, validateRequired,
} from "../../utils/validations";

const NewPanelUser = () => {
  const navigate = useNavigate();
  const { id } = useParams(); 
  console.log("NewPanelUser - id:", id);

  const form = useForm({
    initialValues: { name: "", phone: "", password: "", privilege: "" },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired, validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric, validateNoSpaces, validateMinLength(11)
      ),
      password: combineValidators(validateRequired, validateMaxLength(16), validateMinLength(4)),
      privilege: (value) => (value ? null : "Bu alan zorunludur"),
    },
  });

  const handleSubmit = async (values: any) => {
    try {
      console.log("Gönderilen veri:", { ...values, companyId: id });
      const { data }: any = await createHrUser({ ...values, companyId: id });
      creationNotification("Panel Kullanıcısı", data?.success);
      navigate(`/companies/detail/${id}?tab=user`);
    } catch (error: any) {
      console.log("400 Hata detayı:", error?.response?.data); 
      console.log("Gönderilen payload:", error?.config?.data); 
    }
  };

  return (
    <Container>
      <ActionIcon variant="subtle" color="#5c26ff" size={44} onClick={() => navigate(`/companies/detail/${id}?tab=user`)}>
        <IconArrowLeft size={28} />
      </ActionIcon>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "70vh" }}>
        <PageTitle><Title>Yeni Panel Kullanıcısı</Title></PageTitle>
        <form style={{ display: "flex", flexDirection: "column", gap: "15px", width: "min(468px, 100%)", marginTop: "20px" }}
          onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput label="Ad Soyad" placeholder="Ad Soyad Giriniz." radius={10} size="md" maxLength={40} {...form.getInputProps("name")} />
          <Select label="Yetki" placeholder="Yetki Seçiniz" radius={10} size="md"
            data={[{ value: "admin", label: "Admin" }, { value: "user", label: "User" }]}
            {...form.getInputProps("privilege")} />
          <TextInput label="Telefon" placeholder="Telefon Giriniz." radius={10} size="md" maxLength={11} {...form.getInputProps("phone")} />
          <PasswordInput label="Şifre" placeholder="Şifre Giriniz." radius={10} size="md" maxLength={16} {...form.getInputProps("password")} />
          <Flex gap={10} mt={10}>
            <Button variant="outline" color="gray" radius={10} fullWidth onClick={() => navigate(`/companies/detail/${id}?tab=user`)}>Vazgeç</Button>
            <Button color="#5C26FF" radius={10} type="submit" fullWidth>Oluştur</Button>
          </Flex>
        </form>
      </div>
    </Container>
  );
};

export default NewPanelUser;

const PageTitle = styled.div`display: flex; flex-direction: column; justify-content: center; text-align: center; gap: 12px;`;
const Title = styled.div`font-size: 24px; font-weight: 600; line-height: 24px; color: black;`;